export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_APPFOLIO = 'AppFolio';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_BUILDIUM = 'Buildium';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_PROPERTYWARE = 'Propertyware';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENTVINE = 'Rentvine';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENT_MANAGER = 'Rent Manager';

// PMS with a configurable housing-types sync picker (UpPmsUnitTypesPicker + the settings
// Integrations subpage). Single source of truth — the picker's provider map, the settings
// hub's nav-card gate, and the integrations page all derive from this list.
export const PMS_NAMES_WITH_PICKER = [
  PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENT_MANAGER,
  PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENTVINE,
];

export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_REPORT = 'Report';
export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_API = 'API';
export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_SCRAPER = 'Scraper';
